import { Component, OnInit } from "@angular/core";
import { DilysuService } from "src/app/craidd/gwasanaethau/defnyddiwr/dilysu.service";
import { StorfaDefnyddiwrService } from "src/app/craidd/gwasanaethau/system/storfa-defnyddiwr.service";
import { MatRipple } from "@angular/material/core";
import { MatMenuTrigger, MatMenu, MatMenuItem } from "@angular/material/menu";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-navbar-defnyddiwr",
  templateUrl: "./navbar-defnyddiwr.component.html",
  styleUrls: ["./navbar-defnyddiwr.component.scss"],
  imports: [MatRipple, MatMenuTrigger, FaIconComponent, MatMenu, MatMenuItem, TranslatePipe],
})
export class NavbarDefnyddiwrComponent implements OnInit {
  enwDefnyddiwr: string;
  enwTenant: string;

  constructor(
    private dilysuService: DilysuService,
    private storfaDefnyddiwrService: StorfaDefnyddiwrService,
  ) {}

  ngOnInit(): void {
    const defnyddiwr = this.storfaDefnyddiwrService.nolProffil();

    const wediMewngofnodi = this.dilysuService.wediMewngofnodi();

    if (wediMewngofnodi && defnyddiwr == null) {
      this.dilysuService.allgofnodi();
    }

    this.enwDefnyddiwr = defnyddiwr?.enw;
    this.enwTenant = defnyddiwr?.tenant;
  }

  allgofnodi(): void {
    this.dilysuService.allgofnodi();
  }
}
